import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { ActivityResultType } from "../../types/activityTypes";

interface ActivityCompleteDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  resultType: ActivityResultType | "";
  onResultTypeChange: (value: ActivityResultType | "") => void;
  resultComment: string;
  onResultCommentChange: (value: string) => void;
  resultTypeError: boolean;
  resultCommentError: boolean;
}

/**
 * Dialog for completing an activity with result classification and comment.
 */
const ActivityCompleteDialog = ({
  open,
  onClose,
  onSubmit,
  isSubmitting,
  resultType,
  onResultTypeChange,
  resultComment,
  onResultCommentChange,
  resultTypeError,
  resultCommentError,
}: ActivityCompleteDialogProps) => {
  const resultCommentHelperText =
    resultType === ActivityResultType.DO_NOT_KEEP_CONTACT
      ? "Bitte gib bei 'Kein weiterer Kontakt' einen Kommentar ein."
      : "Bitte gib einen Kommentar zum Abschluss ein.";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Aktivität abschließen</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} marginTop={0}>
          <Grid item xs={12}>
            <FormControl fullWidth error={resultTypeError}>
              <InputLabel id="activity-result-type-label">Ergebnis</InputLabel>
              <Select
                id="activity-result-type"
                name="activity-result-type"
                labelId="activity-result-type-label"
                label="Ergebnis"
                value={resultType}
                onChange={(event) => onResultTypeChange(event.target.value as ActivityResultType | "")}
              >
                <MenuItem value="" />
                <MenuItem value={ActivityResultType.POTENTIAL_FUTURE_PROJECT}>Potenzielles Folgeprojekt</MenuItem>
                <MenuItem value={ActivityResultType.KEEP_CONTACT}>Kontakt halten</MenuItem>
                <MenuItem value={ActivityResultType.DO_NOT_KEEP_CONTACT}>Kein weiterer Kontakt</MenuItem>
              </Select>
              {resultTypeError ? <FormHelperText>Bitte wähle ein Ergebnis aus.</FormHelperText> : null}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="activity-result-comment"
              name="activity-result-comment"
              fullWidth
              multiline
              rows={3}
              label="Kommentar"
              variant="outlined"
              value={resultComment}
              error={resultCommentError}
              helperText={resultCommentError ? resultCommentHelperText : undefined}
              onChange={(event) => onResultCommentChange(event.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Abbrechen
        </Button>
        <Button onClick={onSubmit} color="primary" disabled={isSubmitting}>
          Aktivität abschließen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityCompleteDialog;
